import { SearchIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import I18n from 'I18n';
import { useCallback } from 'react';
import { useAssociatedObjectsCardRedesignContext } from '../../../context/AssociatedObjectsCardRedesignContext';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function AssociationSearchButton({
  onSearchToggle,
  showSearchInput
}) {
  const {
    onSearchQueryChange
  } = useAssociatedObjectsCardRedesignContext();
  const handleSearchToggle = useCallback(() => {
    onSearchToggle();
    onSearchQueryChange('');
  }, [onSearchToggle, onSearchQueryChange]);
  return /*#__PURE__*/_jsx(View, {
    flexShrink: 0,
    children: /*#__PURE__*/_jsx(IconButton, {
      active: showSearchInput,
      use: "secondary",
      size: "extra-small",
      onClick: handleSearchToggle,
      "aria-label": I18n.text('cardAssociatedObjects.AssociatedObjectsCardSearch.searchButtonAriaLabel'),
      children: /*#__PURE__*/_jsx(SearchIcon, {})
    })
  });
}
export default AssociationSearchButton;